<shared-form-input-radio
  [radioButtonData]="radioButtonData()[0]!"
  [control]="addingByControl"
  [attr.data-testid]="radioButtonData()?.[0]?.testId"
></shared-form-input-radio>

<shared-form-input-radio
  class="ml-[21px]"
  [radioButtonData]="radioButtonData()[1]!"
  [control]="addingByControl"
  [attr.data-testid]="radioButtonData()?.[1]?.testId"
></shared-form-input-radio>
